// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* { 
margin: 0; 
padding: 0; 
box-sizing: border-box; 
font-family: "Poppins", sans-serif; 
} 
:root { 
--background-color1: #fafaff; 
--background-color2: #ffffff; 
--background-color3: #ededed; 
--background-color4: #cad7fda4; 
--primary-color: orange; 
--secondary-color: orange; 
--Border-color: orange; 
--one-use-color: orange; 
--two-use-color: orange; 
} 
body { 
/* background-color: var(--background-color4);  */
max-width: 100%; 
overflow-x: hidden; 
} 

/* header { 
height: 70px; 
width: 100vw; 
padding: 0 30px; 
background-color: var(--background-color1); 
position: fixed; 
z-index: 100; 
box-shadow: 1px 1px 15px rgba(161, 182, 253, 0.825); 
display: flex; 
justify-content: space-between; 
align-items: center; 
}  */

.logo { 
font-size: 27px; 
font-weight: 600; 
color: rgb(47, 141, 70); 
} 

.icn { 
height: 30px; 
} 
.menuicn { 
cursor: pointer; 
} 

.searchbar, 
.message, 
.logosec { 
display: flex; 
align-items: center; 
justify-content: center; 
} 

.searchbar2 { 
display: none; 
} 

.logosec { 
gap: 60px; 
} 

.searchbar input { 
width: 250px; 
height: 42px; 
border-radius: 50px 0 0 50px; 
background-color: var(--background-color3); 
padding: 0 20px; 
font-size: 15px; 
outline: none; 
border: none; 
} 
.searchbtn { 
width: 50px; 
height: 42px; 
display: flex; 
align-items: center; 
justify-content: center; 
border-radius: 0px 50px 50px 0px; 
background-color: var(--secondary-color); 
cursor: pointer; 
} 

.message { 
gap: 40px; 
position: relative; 
cursor: pointer; 
} 
.circle { 
height: 7px; 
width: 7px; 
position: absolute; 
background-color: #fa7bb4; 
border-radius: 50%; 
left: 19px; 
top: 8px; 
} 
.dp { 
height: 40px; 
width: 40px; 
background-color: #626262; 
border-radius: 50%; 
display: flex; 
align-items: center; 
justify-content: center; 
overflow: hidden; 
} 
.main-container { 
display: flex; 
width: 100vw; 
position: relative; 
top: 70px; 
z-index: 1; 
} 
.dpicn { 
height: 42px; 
} 

.main { 
height: calc(100vh - 70px); 
width: 100%; 
overflow-y: scroll; 
overflow-x: hidden; 
/* padding: 40px 30px 30px 30px;  */
} 

.main::-webkit-scrollbar-thumb { 
background-image: 
        linear-gradient(to bottom, rgb(0, 0, 85), rgb(0, 0, 50)); 
} 
.main::-webkit-scrollbar { 
width: 5px; 
} 
.main::-webkit-scrollbar-track { 
background-color: #9e9e9eb2; 
} 

.box-container { 
display: flex; 
justify-content: space-evenly; 
align-items: center; 
flex-wrap: wrap; 
gap: 50px; 
} 
.nav { 
min-height: 91vh; 
width: 250px; 
background-color: var(--background-color2); 
position: absolute; 
top: 0px; 
left: 00; 
box-shadow: 1px 1px 10px rgba(198, 189, 248, 0.825); 
display: flex; 
flex-direction: column; 
justify-content: space-between; 
overflow: hidden; 
padding: 30px 0 20px 10px; 
} 
.navcontainer { 
height: calc(100vh - 70px); 
width: 250px; 
position: relative; 
overflow-y: scroll; 
overflow-x: hidden; 
transition: all 0.5s ease-in-out; 
} 
.navcontainer::-webkit-scrollbar { 
display: none; 
} 
.navclose { 
width: 80px; 
} 
.nav-option { 
width: 250px; 
height: 60px; 
display: flex; 
align-items: center; 
padding: 0 30px 0 20px; 
gap: 20px; 
transition: all 0.1s ease-in-out; 
} 
.nav-option:hover { 
border-left: 5px solid #a2a2a2; 
background-color: #dadada; 
cursor: pointer; 
} 
.nav-img { 
height: 30px; 
} 

.nav-upper-options { 
display: flex; 
flex-direction: column; 
align-items: center; 
gap: 30px; 
} 

.option1 { 
border-left: 5px solid #010058af; 
background-color: var(--Border-color); 
color: white; 
cursor: pointer; 
} 
.option1:hover { 
border-left: 5px solid #010058af; 
background-color: var(--Border-color); 
} 
.box { 
height: 130px; 
width: 230px; 
border-radius: 20px; 
box-shadow: 3px 3px 10px rgba(0, 30, 87, 0.751); 
padding: 20px; 
display: flex; 
align-items: center; 
justify-content: space-around; 
cursor: pointer; 
transition: transform 0.3s ease-in-out; 
} 
.box:hover { 
transform: scale(1.08); 
} 

.box:nth-child(1) { 
background-color: var(--one-use-color); 
} 
.box:nth-child(2) { 
background-color: var(--two-use-color); 
} 
.box:nth-child(3) { 
background-color: var(--one-use-color); 
} 
.box:nth-child(4) { 
background-color: var(--two-use-color); 
} 

.box img { 
height: 50px; 
} 
.box .text { 
color: white; 
} 
.topic { 
font-size: 13px; 
font-weight: 400; 
letter-spacing: 1px; 
} 

.topic-heading { 
font-size: 30px; 
letter-spacing: 3px; 
} 

.report-container { 
min-height: 300px; 
max-width: 1200px; 
margin: 70px auto 0px auto; 
background-color: #ffffff; 
border-radius: 30px; 
box-shadow: 3px 3px 10px rgb(188, 188, 188); 
padding: 0px 20px 20px 20px; 
} 
.report-header { 
height: 80px; 
width: 100%; 
display: flex; 
align-items: center; 
justify-content: space-between; 
padding: 20px 20px 10px 20px; 
border-bottom: 2px solid rgba(0, 20, 151, 0.59); 
} 

.recent-Articles { 
font-size: 30px; 
font-weight: 600; 
color: orange; 
} 

.view { 
height: 35px; 
width: 90px; 
border-radius: 8px; 
background-color: orange; 
color: white; 
font-size: 15px; 
border: none; 
cursor: pointer; 
} 

.report-body { 
max-width: 1160px; 
overflow-x: auto; 
padding: 20px; 
} 
.report-topic-heading, 
.item1 { 
width: 1120px; 
display: flex; 
justify-content: space-between; 
align-items: center; 
} 
.t-op { 
font-size: 18px; 
letter-spacing: 0px; 
} 

.items { 
width: 1120px; 
margin-top: 15px; 
} 

.item1 { 
margin-top: 20px; 
} 
.t-op-nextlvl { 
font-size: 14px; 
letter-spacing: 0px; 
font-weight: 600; 
} 

.label-tag { 
width: 100px; 
text-align: center; 
background-color: rgb(0, 177, 0); 
color: white; 
border-radius: 4px; 
}
/* Responsive CSS Here */
@media screen and (max-width: 950px) { 
    .nav-img { 
        height: 25px; 
    } 
    .nav-option { 
        gap: 30px; 
    } 
    .nav-option h3 { 
        font-size: 15px; 
    } 
    .report-topic-heading, 
    .item1, 
    .items { 
        width: 800px; 
    } 
    } 
    
    @media screen and (max-width: 850px) { 
    .nav-img { 
        height: 30px; 
    } 
    .nav-option { 
        gap: 30px; 
    } 
    .nav-option h3 { 
        font-size: 20px; 
    } 
    .report-topic-heading, 
    .item1, 
    .items { 
        width: 700px; 
    } 
    .navcontainer { 
        width: 100vw; 
        position: absolute; 
        transition: all 0.6s ease-in-out; 
        top: 0; 
        left: -100vw; 
    } 
    .nav { 
        width: 100%; 
        position: absolute; 
    } 
    .navclose { 
        left: 00px; 
    } 
    .searchbar { 
        display: none; 
    } 
    .main { 
        padding: 40px 30px 30px 30px; 
    } 
    .searchbar2 { 
        width: 100%; 
        display: flex; 
        margin: 0 0 40px 0; 
        justify-content: center; 
    } 
    .searchbar2 input { 
        width: 250px; 
        height: 42px; 
        border-radius: 50px 0 0 50px; 
        background-color: var(--background-color3); 
        padding: 0 20px; 
        font-size: 15px; 
        border: 2px solid var(--secondary-color); 
    } 
    } 
    
    @media screen and (max-width: 490px) { 
    .message { 
        display: none; 
    } 
    .logosec { 
        width: 100%; 
        justify-content: space-between; 
    } 
    .logo { 
        font-size: 20px; 
    } 
    .menuicn { 
        height: 25px; 
    } 
    .nav-img { 
        height: 25px; 
    } 
    .nav-option { 
        gap: 25px; 
    } 
    .nav-option h3 { 
        font-size: 12px; 
    } 
    .nav-upper-options { 
        gap: 15px; 
    } 
    .recent-Articles { 
        font-size: 20px; 
    } 
    .report-topic-heading, 
    .item1, 
    .items { 
        width: 550px; 
    } 
    } 
    
    @media screen and (max-width: 400px) { 
    .recent-Articles { 
        font-size: 17px; 
    } 
    .view { 
        width: 60px; 
        font-size: 10px; 
        height: 27px; 
    } 
    .report-header { 
        height: 60px; 
        padding: 10px 10px 5px 10px; 
    } 
    .searchbtn img { 
        height: 20px; 
    } 
    } 
    
    @media screen and (max-width: 320px) { 
    .recent-Articles { 
        font-size: 12px; 
    } 
    .view { 
        width: 50px; 
        font-size: 8px; 
        height: 27px; 
    } 
    .report-header { 
        height: 60px; 
        padding: 10px 5px 5px 5px; 
    } 
    .t-op { 
        font-size: 12px; 
    } 
    .t-op-nextlvl { 
        font-size: 10px; 
    } 
    .report-topic-heading, 
    .item1, 
    .items { 
        width: 300px; 
    } 
    .report-body { 
        padding: 10px; 
    } 
    .label-tag { 
        width: 70px; 
    } 
    .searchbtn { 
        width: 40px; 
    } 
    .searchbar2 input { 
        width: 180px; 
    } 
}
.ck-editor__editable {
    min-height: 300px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/header/style.css"],"names":[],"mappings":"AAGA;AACA,SAAS;AACT,UAAU;AACV,sBAAsB;AACtB,kCAAkC;AAClC;AACA;AACA,4BAA4B;AAC5B,4BAA4B;AAC5B,4BAA4B;AAC5B,8BAA8B;AAC9B,uBAAuB;AACvB,yBAAyB;AACzB,sBAAsB;AACtB,uBAAuB;AACvB,uBAAuB;AACvB;AACA;AACA,iDAAiD;AACjD,eAAe;AACf,kBAAkB;AAClB;;AAEA;;;;;;;;;;;IAWI;;AAEJ;AACA,eAAe;AACf,gBAAgB;AAChB,uBAAuB;AACvB;;AAEA;AACA,YAAY;AACZ;AACA;AACA,eAAe;AACf;;AAEA;;;AAGA,aAAa;AACb,mBAAmB;AACnB,uBAAuB;AACvB;;AAEA;AACA,aAAa;AACb;;AAEA;AACA,SAAS;AACT;;AAEA;AACA,YAAY;AACZ,YAAY;AACZ,4BAA4B;AAC5B,0CAA0C;AAC1C,eAAe;AACf,eAAe;AACf,aAAa;AACb,YAAY;AACZ;AACA;AACA,WAAW;AACX,YAAY;AACZ,aAAa;AACb,mBAAmB;AACnB,uBAAuB;AACvB,gCAAgC;AAChC,wCAAwC;AACxC,eAAe;AACf;;AAEA;AACA,SAAS;AACT,kBAAkB;AAClB,eAAe;AACf;AACA;AACA,WAAW;AACX,UAAU;AACV,kBAAkB;AAClB,yBAAyB;AACzB,kBAAkB;AAClB,UAAU;AACV,QAAQ;AACR;AACA;AACA,YAAY;AACZ,WAAW;AACX,yBAAyB;AACzB,kBAAkB;AAClB,aAAa;AACb,mBAAmB;AACnB,uBAAuB;AACvB,gBAAgB;AAChB;AACA;AACA,aAAa;AACb,YAAY;AACZ,kBAAkB;AAClB,SAAS;AACT,UAAU;AACV;AACA;AACA,YAAY;AACZ;;AAEA;AACA,0BAA0B;AAC1B,WAAW;AACX,kBAAkB;AAClB,kBAAkB;AAClB,mCAAmC;AACnC;;AAEA;AACA;gEACgE;AAChE;AACA;AACA,UAAU;AACV;AACA;AACA,2BAA2B;AAC3B;;AAEA;AACA,aAAa;AACb,6BAA6B;AAC7B,mBAAmB;AACnB,eAAe;AACf,SAAS;AACT;AACA;AACA,gBAAgB;AAChB,YAAY;AACZ,0CAA0C;AAC1C,kBAAkB;AAClB,QAAQ;AACR,QAAQ;AACR,mDAAmD;AACnD,aAAa;AACb,sBAAsB;AACtB,8BAA8B;AAC9B,gBAAgB;AAChB,yBAAyB;AACzB;AACA;AACA,0BAA0B;AAC1B,YAAY;AACZ,kBAAkB;AAClB,kBAAkB;AAClB,kBAAkB;AAClB,gCAAgC;AAChC;AACA;AACA,aAAa;AACb;AACA;AACA,WAAW;AACX;AACA;AACA,YAAY;AACZ,YAAY;AACZ,aAAa;AACb,mBAAmB;AACnB,sBAAsB;AACtB,SAAS;AACT,gCAAgC;AAChC;AACA;AACA,8BAA8B;AAC9B,yBAAyB;AACzB,eAAe;AACf;AACA;AACA,YAAY;AACZ;;AAEA;AACA,aAAa;AACb,sBAAsB;AACtB,mBAAmB;AACnB,SAAS;AACT;;AAEA;AACA,gCAAgC;AAChC,qCAAqC;AACrC,YAAY;AACZ,eAAe;AACf;AACA;AACA,gCAAgC;AAChC,qCAAqC;AACrC;AACA;AACA,aAAa;AACb,YAAY;AACZ,mBAAmB;AACnB,+CAA+C;AAC/C,aAAa;AACb,aAAa;AACb,mBAAmB;AACnB,6BAA6B;AAC7B,eAAe;AACf,sCAAsC;AACtC;AACA;AACA,sBAAsB;AACtB;;AAEA;AACA,sCAAsC;AACtC;AACA;AACA,sCAAsC;AACtC;AACA;AACA,sCAAsC;AACtC;AACA;AACA,sCAAsC;AACtC;;AAEA;AACA,YAAY;AACZ;AACA;AACA,YAAY;AACZ;AACA;AACA,eAAe;AACf,gBAAgB;AAChB,mBAAmB;AACnB;;AAEA;AACA,eAAe;AACf,mBAAmB;AACnB;;AAEA;AACA,iBAAiB;AACjB,iBAAiB;AACjB,0BAA0B;AAC1B,yBAAyB;AACzB,mBAAmB;AACnB,2CAA2C;AAC3C,2BAA2B;AAC3B;AACA;AACA,YAAY;AACZ,WAAW;AACX,aAAa;AACb,mBAAmB;AACnB,8BAA8B;AAC9B,4BAA4B;AAC5B,+CAA+C;AAC/C;;AAEA;AACA,eAAe;AACf,gBAAgB;AAChB,aAAa;AACb;;AAEA;AACA,YAAY;AACZ,WAAW;AACX,kBAAkB;AAClB,wBAAwB;AACxB,YAAY;AACZ,eAAe;AACf,YAAY;AACZ,eAAe;AACf;;AAEA;AACA,iBAAiB;AACjB,gBAAgB;AAChB,aAAa;AACb;AACA;;AAEA,aAAa;AACb,aAAa;AACb,8BAA8B;AAC9B,mBAAmB;AACnB;AACA;AACA,eAAe;AACf,mBAAmB;AACnB;;AAEA;AACA,aAAa;AACb,gBAAgB;AAChB;;AAEA;AACA,gBAAgB;AAChB;AACA;AACA,eAAe;AACf,mBAAmB;AACnB,gBAAgB;AAChB;;AAEA;AACA,YAAY;AACZ,kBAAkB;AAClB,gCAAgC;AAChC,YAAY;AACZ,kBAAkB;AAClB;AACA,wBAAwB;AACxB;IACI;QACI,YAAY;IAChB;IACA;QACI,SAAS;IACb;IACA;QACI,eAAe;IACnB;IACA;;;QAGI,YAAY;IAChB;IACA;;IAEA;IACA;QACI,YAAY;IAChB;IACA;QACI,SAAS;IACb;IACA;QACI,eAAe;IACnB;IACA;;;QAGI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,kBAAkB;QAClB,gCAAgC;QAChC,MAAM;QACN,YAAY;IAChB;IACA;QACI,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,WAAW;QACX,aAAa;QACb,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;QACI,YAAY;QACZ,YAAY;QACZ,4BAA4B;QAC5B,0CAA0C;QAC1C,eAAe;QACf,eAAe;QACf,wCAAwC;IAC5C;IACA;;IAEA;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,8BAA8B;IAClC;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,SAAS;IACb;IACA;QACI,eAAe;IACnB;IACA;QACI,SAAS;IACb;IACA;QACI,eAAe;IACnB;IACA;;;QAGI,YAAY;IAChB;IACA;;IAEA;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,eAAe;QACf,YAAY;IAChB;IACA;QACI,YAAY;QACZ,2BAA2B;IAC/B;IACA;QACI,YAAY;IAChB;IACA;;IAEA;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,cAAc;QACd,YAAY;IAChB;IACA;QACI,YAAY;QACZ,yBAAyB;IAC7B;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;;;QAGI,YAAY;IAChB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;IAChB;AACJ;AACA;IACI,4BAA4B;AAChC","sourcesContent":["@import url( \n\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\"); \n\n* { \nmargin: 0; \npadding: 0; \nbox-sizing: border-box; \nfont-family: \"Poppins\", sans-serif; \n} \n:root { \n--background-color1: #fafaff; \n--background-color2: #ffffff; \n--background-color3: #ededed; \n--background-color4: #cad7fda4; \n--primary-color: orange; \n--secondary-color: orange; \n--Border-color: orange; \n--one-use-color: orange; \n--two-use-color: orange; \n} \nbody { \n/* background-color: var(--background-color4);  */\nmax-width: 100%; \noverflow-x: hidden; \n} \n\n/* header { \nheight: 70px; \nwidth: 100vw; \npadding: 0 30px; \nbackground-color: var(--background-color1); \nposition: fixed; \nz-index: 100; \nbox-shadow: 1px 1px 15px rgba(161, 182, 253, 0.825); \ndisplay: flex; \njustify-content: space-between; \nalign-items: center; \n}  */\n\n.logo { \nfont-size: 27px; \nfont-weight: 600; \ncolor: rgb(47, 141, 70); \n} \n\n.icn { \nheight: 30px; \n} \n.menuicn { \ncursor: pointer; \n} \n\n.searchbar, \n.message, \n.logosec { \ndisplay: flex; \nalign-items: center; \njustify-content: center; \n} \n\n.searchbar2 { \ndisplay: none; \n} \n\n.logosec { \ngap: 60px; \n} \n\n.searchbar input { \nwidth: 250px; \nheight: 42px; \nborder-radius: 50px 0 0 50px; \nbackground-color: var(--background-color3); \npadding: 0 20px; \nfont-size: 15px; \noutline: none; \nborder: none; \n} \n.searchbtn { \nwidth: 50px; \nheight: 42px; \ndisplay: flex; \nalign-items: center; \njustify-content: center; \nborder-radius: 0px 50px 50px 0px; \nbackground-color: var(--secondary-color); \ncursor: pointer; \n} \n\n.message { \ngap: 40px; \nposition: relative; \ncursor: pointer; \n} \n.circle { \nheight: 7px; \nwidth: 7px; \nposition: absolute; \nbackground-color: #fa7bb4; \nborder-radius: 50%; \nleft: 19px; \ntop: 8px; \n} \n.dp { \nheight: 40px; \nwidth: 40px; \nbackground-color: #626262; \nborder-radius: 50%; \ndisplay: flex; \nalign-items: center; \njustify-content: center; \noverflow: hidden; \n} \n.main-container { \ndisplay: flex; \nwidth: 100vw; \nposition: relative; \ntop: 70px; \nz-index: 1; \n} \n.dpicn { \nheight: 42px; \n} \n\n.main { \nheight: calc(100vh - 70px); \nwidth: 100%; \noverflow-y: scroll; \noverflow-x: hidden; \n/* padding: 40px 30px 30px 30px;  */\n} \n\n.main::-webkit-scrollbar-thumb { \nbackground-image: \n        linear-gradient(to bottom, rgb(0, 0, 85), rgb(0, 0, 50)); \n} \n.main::-webkit-scrollbar { \nwidth: 5px; \n} \n.main::-webkit-scrollbar-track { \nbackground-color: #9e9e9eb2; \n} \n\n.box-container { \ndisplay: flex; \njustify-content: space-evenly; \nalign-items: center; \nflex-wrap: wrap; \ngap: 50px; \n} \n.nav { \nmin-height: 91vh; \nwidth: 250px; \nbackground-color: var(--background-color2); \nposition: absolute; \ntop: 0px; \nleft: 00; \nbox-shadow: 1px 1px 10px rgba(198, 189, 248, 0.825); \ndisplay: flex; \nflex-direction: column; \njustify-content: space-between; \noverflow: hidden; \npadding: 30px 0 20px 10px; \n} \n.navcontainer { \nheight: calc(100vh - 70px); \nwidth: 250px; \nposition: relative; \noverflow-y: scroll; \noverflow-x: hidden; \ntransition: all 0.5s ease-in-out; \n} \n.navcontainer::-webkit-scrollbar { \ndisplay: none; \n} \n.navclose { \nwidth: 80px; \n} \n.nav-option { \nwidth: 250px; \nheight: 60px; \ndisplay: flex; \nalign-items: center; \npadding: 0 30px 0 20px; \ngap: 20px; \ntransition: all 0.1s ease-in-out; \n} \n.nav-option:hover { \nborder-left: 5px solid #a2a2a2; \nbackground-color: #dadada; \ncursor: pointer; \n} \n.nav-img { \nheight: 30px; \n} \n\n.nav-upper-options { \ndisplay: flex; \nflex-direction: column; \nalign-items: center; \ngap: 30px; \n} \n\n.option1 { \nborder-left: 5px solid #010058af; \nbackground-color: var(--Border-color); \ncolor: white; \ncursor: pointer; \n} \n.option1:hover { \nborder-left: 5px solid #010058af; \nbackground-color: var(--Border-color); \n} \n.box { \nheight: 130px; \nwidth: 230px; \nborder-radius: 20px; \nbox-shadow: 3px 3px 10px rgba(0, 30, 87, 0.751); \npadding: 20px; \ndisplay: flex; \nalign-items: center; \njustify-content: space-around; \ncursor: pointer; \ntransition: transform 0.3s ease-in-out; \n} \n.box:hover { \ntransform: scale(1.08); \n} \n\n.box:nth-child(1) { \nbackground-color: var(--one-use-color); \n} \n.box:nth-child(2) { \nbackground-color: var(--two-use-color); \n} \n.box:nth-child(3) { \nbackground-color: var(--one-use-color); \n} \n.box:nth-child(4) { \nbackground-color: var(--two-use-color); \n} \n\n.box img { \nheight: 50px; \n} \n.box .text { \ncolor: white; \n} \n.topic { \nfont-size: 13px; \nfont-weight: 400; \nletter-spacing: 1px; \n} \n\n.topic-heading { \nfont-size: 30px; \nletter-spacing: 3px; \n} \n\n.report-container { \nmin-height: 300px; \nmax-width: 1200px; \nmargin: 70px auto 0px auto; \nbackground-color: #ffffff; \nborder-radius: 30px; \nbox-shadow: 3px 3px 10px rgb(188, 188, 188); \npadding: 0px 20px 20px 20px; \n} \n.report-header { \nheight: 80px; \nwidth: 100%; \ndisplay: flex; \nalign-items: center; \njustify-content: space-between; \npadding: 20px 20px 10px 20px; \nborder-bottom: 2px solid rgba(0, 20, 151, 0.59); \n} \n\n.recent-Articles { \nfont-size: 30px; \nfont-weight: 600; \ncolor: orange; \n} \n\n.view { \nheight: 35px; \nwidth: 90px; \nborder-radius: 8px; \nbackground-color: orange; \ncolor: white; \nfont-size: 15px; \nborder: none; \ncursor: pointer; \n} \n\n.report-body { \nmax-width: 1160px; \noverflow-x: auto; \npadding: 20px; \n} \n.report-topic-heading, \n.item1 { \nwidth: 1120px; \ndisplay: flex; \njustify-content: space-between; \nalign-items: center; \n} \n.t-op { \nfont-size: 18px; \nletter-spacing: 0px; \n} \n\n.items { \nwidth: 1120px; \nmargin-top: 15px; \n} \n\n.item1 { \nmargin-top: 20px; \n} \n.t-op-nextlvl { \nfont-size: 14px; \nletter-spacing: 0px; \nfont-weight: 600; \n} \n\n.label-tag { \nwidth: 100px; \ntext-align: center; \nbackground-color: rgb(0, 177, 0); \ncolor: white; \nborder-radius: 4px; \n}\n/* Responsive CSS Here */\n@media screen and (max-width: 950px) { \n    .nav-img { \n        height: 25px; \n    } \n    .nav-option { \n        gap: 30px; \n    } \n    .nav-option h3 { \n        font-size: 15px; \n    } \n    .report-topic-heading, \n    .item1, \n    .items { \n        width: 800px; \n    } \n    } \n    \n    @media screen and (max-width: 850px) { \n    .nav-img { \n        height: 30px; \n    } \n    .nav-option { \n        gap: 30px; \n    } \n    .nav-option h3 { \n        font-size: 20px; \n    } \n    .report-topic-heading, \n    .item1, \n    .items { \n        width: 700px; \n    } \n    .navcontainer { \n        width: 100vw; \n        position: absolute; \n        transition: all 0.6s ease-in-out; \n        top: 0; \n        left: -100vw; \n    } \n    .nav { \n        width: 100%; \n        position: absolute; \n    } \n    .navclose { \n        left: 00px; \n    } \n    .searchbar { \n        display: none; \n    } \n    .main { \n        padding: 40px 30px 30px 30px; \n    } \n    .searchbar2 { \n        width: 100%; \n        display: flex; \n        margin: 0 0 40px 0; \n        justify-content: center; \n    } \n    .searchbar2 input { \n        width: 250px; \n        height: 42px; \n        border-radius: 50px 0 0 50px; \n        background-color: var(--background-color3); \n        padding: 0 20px; \n        font-size: 15px; \n        border: 2px solid var(--secondary-color); \n    } \n    } \n    \n    @media screen and (max-width: 490px) { \n    .message { \n        display: none; \n    } \n    .logosec { \n        width: 100%; \n        justify-content: space-between; \n    } \n    .logo { \n        font-size: 20px; \n    } \n    .menuicn { \n        height: 25px; \n    } \n    .nav-img { \n        height: 25px; \n    } \n    .nav-option { \n        gap: 25px; \n    } \n    .nav-option h3 { \n        font-size: 12px; \n    } \n    .nav-upper-options { \n        gap: 15px; \n    } \n    .recent-Articles { \n        font-size: 20px; \n    } \n    .report-topic-heading, \n    .item1, \n    .items { \n        width: 550px; \n    } \n    } \n    \n    @media screen and (max-width: 400px) { \n    .recent-Articles { \n        font-size: 17px; \n    } \n    .view { \n        width: 60px; \n        font-size: 10px; \n        height: 27px; \n    } \n    .report-header { \n        height: 60px; \n        padding: 10px 10px 5px 10px; \n    } \n    .searchbtn img { \n        height: 20px; \n    } \n    } \n    \n    @media screen and (max-width: 320px) { \n    .recent-Articles { \n        font-size: 12px; \n    } \n    .view { \n        width: 50px; \n        font-size: 8px; \n        height: 27px; \n    } \n    .report-header { \n        height: 60px; \n        padding: 10px 5px 5px 5px; \n    } \n    .t-op { \n        font-size: 12px; \n    } \n    .t-op-nextlvl { \n        font-size: 10px; \n    } \n    .report-topic-heading, \n    .item1, \n    .items { \n        width: 300px; \n    } \n    .report-body { \n        padding: 10px; \n    } \n    .label-tag { \n        width: 70px; \n    } \n    .searchbtn { \n        width: 40px; \n    } \n    .searchbar2 input { \n        width: 180px; \n    } \n}\n.ck-editor__editable {\n    min-height: 300px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
